'use strict';
var angular = require('angular');

var inputSelectFlattenedFormsCtrl = ['$timeout', function ($timeout) {
    var _this = this;

    if (!this.required) { this.required = false; }
    if (!this.inputvalue) { this.inputvalue = ""; }
    if (!this.optionlist) { this.optionlist = []; }

    this.focusInput = false;
    this.focusSelect = false;
    this.showSuggestionsDialog = false,
    this.suggestions = []; // Suggestions array (string)
    this.selectedSuggestion = null; // Selected option

    // Set formName in the input when formId is provided
    this.initializeFormName = function() {
        const form = this.optionlist.find(option => option.formId === this.inputvalue);
        if (form) {
            this.inputFormName = form.formName; // Display formName in input
            this.departmentid = form.departmentId;
        } else {
            this.inputFormName = ""; // Clear the input if formId is invalid
            this.departmentid = "";
        }
    };
    if (this.inputValue != '') {
        this.initializeFormName();
    }

    // Search suggestions
    this.search = function() {
        if (!this.inputFormName) {
            this.suggestions = this.optionlist;
            this.showSuggestionsDialog = true;
            return;
        }
        this.showSuggestionsDialog = true; // When a key is pressed, suggestions are displayed if there are elements in the array.

        this.suggestions = this.optionlist.filter(function(suggestion) {
            return suggestion.formName.toLowerCase().includes(_this.inputFormName.toLowerCase()) || suggestion.departmentName.toLowerCase().includes(_this.inputFormName.toLowerCase());
        });
    };

    this.selectSuggestion = function() {
        if (this.selectedSuggestion) {
            this.inputvalue = this.selectedSuggestion.formId;
            this.departmentid = this.selectedSuggestion.departmentId;
            this.inputFormName = this.selectedSuggestion.formName;
            $timeout(() => {
                this.reload();
            }, 100);
        }
        this.suggestions = [];
    };

    this.enter = function(event) {
        if (event.keyCode === 13) { // 'Enter' key
            this.selectSuggestion();
            event.preventDefault(); // Prevents the browser's default behavior
            event.stopPropagation(); // Stops the event's propagation to prevent it from affecting other parts of the application.
        }
    }

    // The $timeout function allows select to execute "selectSuggestion" function, before hidding the select dialog
    this.onBlur = function() {    
        $timeout(() => {
            if (!this.focusSelect) {
                this.showSuggestionsDialog = false;
                this.suggestions = [];
            }
            this.focusInput = false;
            this.focusSelect = false;
        }, 100);
    };

    // 'search' icon 
    this.searchIcon = function() {
        this.search();
        document.getElementById('searchInput').focus();
    }

    // Clear input from 'x' icon 
    this.clearInput = function() {
        _this.inputFormName = '';
        _this.inputvalue = '';
        _this.departmentid = '';
        $timeout(() => {
            if (_this.reload) {
                _this.reload();
            }
        }, 100);
    }

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            inputvalue: '=',
            optionlist: '=',
            required: '=',
            reload: '&',
            departmentid: '='
        },
        controller: inputSelectFlattenedFormsCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/inputSelectFlattenedFormsDirective.html'
    };
};
